import React, { useContext } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { RedirectContext } from '@store/store';
import {
  AnalyticsProductType,
  ClickCtaType,
  ClickCtaUxSource,
  ClickGetPlanEventProperties,
} from 'src/types/analytics.types';
import { sendRudderStackAnalyticEvent } from '@utils/analytics';

const StaticPricingCards = () => {
  const { handlePricingCardClick } = useContext(RedirectContext);

  const handleFreePlanClick = () => {
    handlePricingCardClick(
      {
        key: 'free',
        planPrice: {
          monthly: { planId: 'free' },
          yearly: { planId: 'free' },
        },
        CTA: {
          label: 'Try for free',
          onClick: () => {},
        },
      },
      true,
      { free: 1 },
      'free',
      1,
    );

    const analyticsProperties: ClickGetPlanEventProperties = {
      plan_price_id: 'free',
      product: AnalyticsProductType.AI,
      seats: -1,
      type: ClickCtaType.ClickGetPlan,
      ux_source: ClickCtaUxSource.PricingCard,
    };

    sendRudderStackAnalyticEvent({
      event_name: 'click_cta',
      event_properties: analyticsProperties,
    });
  };

  const handleEnterprisePlanClick = () => {
    const analyticsProperties: ClickGetPlanEventProperties = {
      plan_price_id: 'enterprise',
      product: AnalyticsProductType.AI,
      seats: -1,
      type: ClickCtaType.ClickGetPlan,
      ux_source: ClickCtaUxSource.PricingCard,
    };

    sendRudderStackAnalyticEvent({
      event_name: 'click_cta',
      event_properties: analyticsProperties,
    });

    window.open('https://form.typeform.com/to/Xuvp544D');
  };

  return (
    <div
      className={ivclass(
        'iv-flex iv-justify-center iv-gap-30',
        'iv-col-span-12 md:iv-col-span-8 sm:iv-col-span-4',
        'xl:iv-px-15',
        'iv-w-full',
      )}
    >
      <div
        className={ivclass(
          'iv-flex iv-justify-center',
          'sm:iv-flex-col md:iv-flex-col pricingcollapse:iv-flex-col',
          'iv-gap-30 md:iv-gap-35 sm:iv-gap-30',
          'iv-mt-10 iv-items-center',
          'xl:iv-pb-4',
          'iv-w-full',
        )}
      >
        <div
          className={ivclass(
            'iv-bg-grey-0 iv-border iv-border-grey-20 iv-rounded-2xl iv-p-25 iv-flex iv-flex-col iv-items-start iv-justify-between',
            'iv-w-full iv-h-full iv-max-h-[300px] iv-max-w-[675px] md:iv-max-w-[600px]',
            'sm:iv-w-full sm:iv-h-auto',
          )}
        >
          <div>
            <div
              className={ivclass(
                'iv-text-heading-s sm:iv-text-[30px] iv-leading-[45px]',
                'iv-font-bold',
                'iv-mb-10',
              )}
            >
              Free
            </div>
            <div className={ivclass('iv-text-body-5xl iv-mb-10')}>$0</div>
            <div className={ivclass('iv-text-body-xl iv-mb-20')}>
              10 AI mins per week, 1 Express avatar, 4 Exports per week with
              invideo watermark.
              <br />
              No access to generative features.
            </div>
          </div>
          <button
            className={ivclass(
              'iv-border iv-bg-[#000] iv-text-grey-0 iv-border-grey-40 ',
              'iv-rounded-lg iv-px-30 iv-py-10 iv-text-body-2xl iv-font-semibold',
            )}
            type="button"
            onClick={handleFreePlanClick}
          >
            Try for free
          </button>
        </div>

        <div
          className={ivclass(
            'iv-bg-grey-0 iv-border iv-border-grey-20 iv-rounded-2xl iv-p-25 iv-flex iv-flex-col iv-items-start iv-justify-between',
            'iv-w-full iv-h-full iv-max-h-[300px] iv-max-w-[675px] md:iv-max-w-[600px]',
            'sm:iv-w-full sm:iv-h-auto',
          )}
        >
          <div>
            <div
              className={ivclass(
                'iv-text-heading-s sm:iv-text-[30px] iv-leading-[45px]',
                'iv-font-bold',
                'iv-mb-10',
              )}
            >
              Enterprise
            </div>
            <div className={ivclass('iv-text-body-5xl iv-mb-10')}>Custom</div>
            <div className={ivclass('iv-text-body-xl iv-mb-20')}>
              Custom solutions for large organizations. Advanced security and
              flexible pricing based on your needs.
            </div>
          </div>
          <button
            className={ivclass(
              'iv-bg-v30-primary-button-blue iv-text-grey-0 iv-rounded-lg iv-px-30 iv-py-10 iv-text-body-2xl iv-font-semibold',
            )}
            type="button"
            onClick={handleEnterprisePlanClick}
          >
            Contact us
          </button>
        </div>
      </div>
    </div>
  );
};

export default StaticPricingCards;
